import type {
  ComponentType,
  FunctionComponent,
  PropsWithChildren,
} from "react";

import type {
  IStiggService,
  TokenwiseCheckoutProps,
  TokenwisePaywallProps,
  TokenwisePlanState,
} from "./stigg.types";

/* Used when no Stigg client key is configured (local/dev/on-prem). Renders
 * children untouched, reports "entitled" so nothing is gated, and never calls
 * out to Stigg. */
export class NoopStiggService implements IStiggService {
  StiggProvider: FunctionComponent<PropsWithChildren<unknown>> = ({
    children,
  }) => <>{children}</>;

  useTokenwisePlan = (): TokenwisePlanState => ({
    isLoading: false,
    hasSubscription: false,
    isEntitled: true,
    isTrial: false,
  });

  // No paywall/checkout without Stigg configured.
  Paywall: ComponentType<TokenwisePaywallProps> = () => null;
  Checkout: ComponentType<TokenwiseCheckoutProps> = () => null;
}
